/* Envuelto en una IIFE con guarda, mismo patron que dd0-quote-slider.js. Este fichero lo carga
   mas de una seccion (y main-product lo emite dentro del bucle de bloques), asi que en una misma
   pagina el navegador puede ejecutarlo DOS veces. Con las declaraciones en el ambito global la
   segunda ejecucion muere entera con "Identifier ... has already been declared" antes de correr
   una linea. El cuerpo se deja con su sangria original a proposito: el diff es el envoltorio.
   Comprobacion: node tools/check_scripts_twice.js */
(() => {
  if (customElements.get('dd0-results')) return;

/* ⚜️DD0 - Results
   Animates each percentage ring (conic-gradient fill + count-up number)
   and each big-number stat the first time the section scrolls into view.
   Honours reduced motion. */
class DD0Results extends HTMLElement {
  connectedCallback() {
    this.rings = Array.from(this.querySelectorAll('.dd0-results__ring'));
    this.numbers = Array.from(this.querySelectorAll('.dd0-results__number-value'));
    if (!this.rings.length && !this.numbers.length) return;

    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) {
      this.rings.forEach((ring) => this.setFinal(ring));
      this.numbers.forEach((el) => this.setFinalNumber(el));
      return;
    }

    this.observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          obs.disconnect();
          this.rings.forEach((ring, i) => this.animate(ring, i * 120));
          this.numbers.forEach((el, i) => this.animateNumber(el, i * 120));
        });
      },
      { rootMargin: '0px 0px -10% 0px' }
    );
    this.observer.observe(this);
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
  }

  setFinal(ring) {
    const target = parseFloat(ring.dataset.percentage) || 0;
    ring.style.setProperty('--dd0-pct', target + '%');
    const num = ring.querySelector('.dd0-results__ring-num');
    if (num) num.textContent = Math.round(target);
  }

  setFinalNumber(el) {
    const target = parseFloat(el.dataset.target) || 0;
    el.textContent = Math.round(target).toLocaleString();
  }

  runCountUp(target, delay, onFrame) {
    const duration = 1200;
    const start = performance.now() + delay;

    const tick = (now) => {
      const elapsed = now - start;
      if (elapsed < 0) {
        requestAnimationFrame(tick);
        return;
      }
      const t = Math.min(elapsed / duration, 1);
      // easeOutCubic
      const eased = 1 - Math.pow(1 - t, 3);
      onFrame(target * eased);
      if (t < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  }

  animate(ring, delay) {
    const target = parseFloat(ring.dataset.percentage) || 0;
    const num = ring.querySelector('.dd0-results__ring-num');
    this.runCountUp(target, delay, (value) => {
      ring.style.setProperty('--dd0-pct', value + '%');
      if (num) num.textContent = Math.round(value);
    });
  }

  animateNumber(el, delay) {
    const target = parseFloat(el.dataset.target) || 0;
    this.runCountUp(target, delay, (value) => {
      el.textContent = Math.round(value).toLocaleString();
    });
  }
}

if (!customElements.get('dd0-results')) {
  customElements.define('dd0-results', DD0Results);
}

})();
